export default __webpack_public_path__ + "static/media/niche-service.b040b742.jpeg";